<div class="auth">
  <div class="auth-glow" aria-hidden="true"></div>

  <div class="auth-card">
    <span class="brand">
      <svg class="brand-plane" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2 13l9-2 4-8 1 0-2 8 7 1 0 1-7 1 2 8-1 0-4-8-9-2 0-1z" fill="currentColor"/>
      </svg>
      <span class="brand-word">iFly<span class="brand-word-accent">Finance</span></span>
    </span>

    <p class="eyebrow">New insurance company</p>
    <h1 class="hero-title">Company sign up</h1>
    <p class="hero-sub">Join iFlyFinance and start financing aviation premiums.</p>

    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">
      <!-- Company Information Section -->
      <div class="form-section">
        <h2 class="section-label">Company Information</h2>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="companyName" placeholder="Enter your company name">
            <mat-error>{{ getErrorMessage('companyName') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Address</mat-label>
            <input matInput formControlName="address" placeholder="Enter company address">
            <mat-icon matSuffix>location_on</mat-icon>
            <mat-error>{{ getErrorMessage('address') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="addressLine2" placeholder="Apartment, suite, unit, etc. (optional)">
            <mat-icon matSuffix>location_on</mat-icon>
            <mat-error>{{ getErrorMessage('addressLine2') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>City</mat-label>
            <input matInput formControlName="city" placeholder="Enter city">
            <mat-error>{{ getErrorMessage('city') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>State</mat-label>
            <input matInput formControlName="state" placeholder="Enter state">
            <mat-error>{{ getErrorMessage('state') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>ZIP Code</mat-label>
            <input matInput formControlName="zip" placeholder="Enter ZIP code">
            <mat-error>{{ getErrorMessage('zip') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phone" placeholder="Enter phone number">
            <mat-icon matSuffix>phone</mat-icon>
            <mat-error>{{ getErrorMessage('phone') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Company Email</mat-label>
            <input matInput type="email" formControlName="email" placeholder="Enter company email">
            <mat-icon matSuffix>email</mat-icon>
            <mat-error>{{ getErrorMessage('email') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Admin Account Section -->
      <div class="form-section">
        <h2 class="section-label">Admin Account</h2>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Admin First Name</mat-label>
            <input matInput formControlName="adminFirstName" placeholder="Enter first name">
            <mat-icon matSuffix>person</mat-icon>
            <mat-error>{{ getErrorMessage('adminFirstName') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Admin Last Name</mat-label>
            <input matInput formControlName="adminLastName" placeholder="Enter last name">
            <mat-icon matSuffix>person</mat-icon>
            <mat-error>{{ getErrorMessage('adminLastName') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Admin Email</mat-label>
            <input matInput type="email" formControlName="adminEmail" placeholder="Enter admin email">
            <mat-icon matSuffix>email</mat-icon>
            <mat-error>{{ getErrorMessage('adminEmail') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="ifq-field">
            <mat-label>Admin Password</mat-label>
            <input matInput type="password" formControlName="adminPassword" placeholder="Enter admin password">
            <mat-icon matSuffix>lock</mat-icon>
            <mat-error>{{ getErrorMessage('adminPassword') }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="cta" [disabled]="signupForm.invalid || loading">
          <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
          <span>{{ loading ? 'Creating Company…' : 'Create Company' }}</span>
        </button>

        <a class="btn-ghost" routerLink="/">
          <mat-icon>arrow_back</mat-icon>
          Back to Home
        </a>
      </div>
    </form>
  </div>
</div>
